// extracted by mini-css-extract-plugin
export var cartIcon = "_i3-0";
export var cartIconContainer = "_i3-1";